import React from "react";

import Text from "src/components/text";
import { formatTimespent } from "src/services/reports.service";

import styles from "./topAccounts.module.scss";

interface TopAccountListItemProps {
  item: any;
  columnCount: number;
}

const TopAccountListItem: React.FC<TopAccountListItemProps> = ({
  item,
  columnCount,
}) => {
  const { company, analytics } = item;
  return (
    <div key={company.id} className={styles.tableRow}>
      <div className={styles.tableDataContainer}>
        <div className={styles.imageIcon}>
          {company.icon?.thumbnail ? (
            <img src={company.icon.thumbnail} alt="Company Icon" />
          ) : (
            <span className={styles.initials}>
              {company?.charAt(0).toUpperCase() || "U"}
            </span>
          )}
        </div>
        <div className={styles.rightData}>
          <div className={styles.tableDataTitle}>
            <Text text={company || ""} className={styles.title} lines={1} />
          </div>
          <div className={styles.metricsData}>
            Users: {analytics.users || 0}
          </div>
        </div>
      </div>
      <div
        className={styles.analyticsContainer}
        style={{
          gridTemplateColumns: `repeat(${columnCount}, minmax(0, 1fr))`,
        }}
      >
        <div className={styles.tableDataViews}>{analytics.views}</div>
        <div className={styles.tableDataViews}>
          {formatTimespent(analytics.avgTimeSpent || 0)}
        </div>
        <div className={styles.tableDataShares}>{analytics.shares}</div>
      </div>
    </div>
  );
};

export default TopAccountListItem;
